var map = {
	"./banner1.png": 93540,
	"./banner1_en.png": 12848,
	"./banner2.png": 40789,
	"./banner2_en.png": 57687,
	"./diag-active-icon.png": 32863,
	"./diag-content-img.png": 55046,
	"./diag-icon.png": 83874,
	"./eLearn-active-icon.png": 87449,
	"./eLearn-content-img.png": 79791,
	"./eLearn-icon.png": 1008,
	"./ota-active-icon.png": 93764,
	"./ota-content-img.png": 64028,
	"./ota-icon.png": 34082,
	"./production-solution-bg.png": 40128,
	"./service-bg.png": 46752,
	"./service-left.png": 76694,
	"./service_01.png": 79410,
	"./service_01_en.png": 98591,
	"./service_02.png": 85547,
	"./service_02_en.png": 30186,
	"./service_03.png": 30801,
	"./service_03_en.png": 64741,
	"./service_04.png": 79123,
	"./service_04_en.png": 31462,
	"./service_05.png": 42134,
	"./service_05_en.png": 40221,
	"./service_06.png": 61127,
	"./service_06_en.png": 63788,
	"./soa-active-icon.png": 30895,
	"./soa-content-img.png": 56037,
	"./soa-icon.png": 65870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24457;